import { render, staticRenderFns } from "./User-New-Mail.vue?vue&type=template&id=66bf121a&scoped=true&"
import script from "./User-New-Mail.vue?vue&type=script&lang=js&"
export * from "./User-New-Mail.vue?vue&type=script&lang=js&"
import style0 from "./User-New-Mail.vue?vue&type=style&index=0&id=66bf121a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf121a",
  null
  
)

export default component.exports